import { pickBFFCardActionData } from '@sa/bff-contract';
import { Components } from 'botframework-webchat';
import React, { useLayoutEffect } from 'react';
const { AdaptiveCardContent } = Components;
const patchSubmitActions = (node, activityId) => {
    if (node.type === 'Action.Submit') {
        const data = pickBFFCardActionData(node, 'linkedAnswer');
        if (data) {
            data.context.activityId = activityId;
        }
    }
    else {
        const nextNodes = Array.isArray(node) ? node : Object.values(node);
        nextNodes.filter((x) => x != null && typeof x === 'object').forEach((x) => patchSubmitActions(x, activityId));
    }
};
export const BFFAnswerAdaptiveCardContent = (props) => {
    useLayoutEffect(() => {
        if ((props === null || props === void 0 ? void 0 : props.content) && props.activityId) {
            patchSubmitActions(props.content, props.activityId);
        }
    }, [props === null || props === void 0 ? void 0 : props.content, props === null || props === void 0 ? void 0 : props.activityId]);
    return React.createElement(AdaptiveCardContent, { content: props === null || props === void 0 ? void 0 : props.content });
};
//# sourceMappingURL=bffAnswerAdaptiveCardContent.js.map